import Vue from "vue";
import VueRouter from "vue-router";
// import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/views/Index.vue"),
    children: [
      {
        path: "",
        name: "home",
        component: () => import("@/views/Home.vue"),
      },
      {
        path: "/fuwu",
        name: "fuwu",
        component: () => import("@/views/fuwu.vue"),
      },
      {
        path: "/serv",
        name: "serv",
        component: () => import("@/views/servios.vue"),
      },
      {
        path: "/about",
        name: "about",
        component: () => import("@/views/aboutus.vue"),
      },
      {
        path: "/join",
        name: "join",
        component: () => import("@/views/joinus.vue"),
      },
      {
        path: "/link",
        name: "link",
        component: () => import("@/views/linkus.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
